import { IProductWarning, IProductWarningProps } from '../ProductWarning';
import { IDealItem, IMeal } from '~/types/combo';
import { TBooleanInNumber } from '~/types/main';
import { IProductV4, PRODUCT_TYPE } from '~/types/product';

type TMealItemsData = Pick<IProductWarningProps, 'type' | 'combo'>;
type TMealItemsInEditPageData = Pick<IProductWarningProps, 'comboItem' | 'comboItemOrderTypeWarning'>;

export const mealItemsInListWarning = (data: TMealItemsData): IProductWarning | null => {
  const { combo } = data;

  const checkNoItems = (): boolean => {
    if (!data.combo || data.combo.type !== PRODUCT_TYPE.MEAL_COMBO) return false;
    const _combo = data.combo as IMeal;
    return _combo.items.length !== _combo.sizes.length * _combo.choices.length;
  };

  const noItems: boolean = checkNoItems();

  switch (true) {
    case noItems:
      return { message: 'missing_item_mc_warning', maxWidth: 340 };
    case combo?.items?.some((item) => !item.category_status):
      return { message: 'cm_cmgci_not_available_warning', maxWidth: 340 };
    case combo?.items?.some((item) => !item.status):
      return { message: 'cm_cmgci_not_available_warning', maxWidth: 340 };
    case combo?.items?.some((item) => item.out_of_stock):
      return { message: 'cm_cmgci_oos_warning', maxWidth: 340 };
    case !combo?.order_type:
      return { message: 'cmgci_order_type_conflict_oos', maxWidth: 308 };
    case combo?.items?.some((item) => item.is_size):
      return { message: 'cmgci_has_sizes_oos', maxWidth: 246 };
    // TODO: combo exclusions
    case combo?.items?.some((item) => item.is_exclusions):
      return { message: 'cmgci_has_excl_oos', maxWidth: 308 };
    case combo?.items?.some((item) => item.is_donation):
      return { message: 'cmgci_is_donatable_oos', maxWidth: 246 };
    default:
      return null;
  }
};

export const mealItemsInEditPageWarning = (data: TMealItemsInEditPageData): IProductWarning | null => {
  const { comboItem, comboItemOrderTypeWarning } = data;

  let categoryStatus: TBooleanInNumber | undefined = undefined;
  if (comboItem && (comboItem as IProductV4).category) {
    categoryStatus = (comboItem as IProductV4).category?.status;
  } else {
    categoryStatus = (comboItem as IDealItem)?.category_status;
  }

  switch (true) {
    case !categoryStatus:
      return { message: 'item_cat_not_available' };
    case !comboItem?.status:
      return { message: 'item_not_available' };
    case Boolean(comboItem?.out_of_stock):
      return { message: 'item_oos' };
    case Boolean(comboItemOrderTypeWarning):
      return { message: 'cmgci_order_type_conflict', maxWidth: 246 };
    case Boolean(comboItem?.is_size):
      return { message: 'cmgci_has_sizes_oos', maxWidth: 246 };
    // TODO: combo exclusions
    case Boolean(comboItem?.is_exclusions):
      return { message: 'cmgci_has_excl_oos', maxWidth: 308 };
    case Boolean(comboItem?.is_donation):
      return { message: 'donatable_cm_conflict', maxWidth: 246 };
    default:
      return null;
  }
};
